import {
  FETCH_RESOURCE_FILTERS_START,
  FETCH_RESOURCE_FILTERS_SUCCESS,
  FETCH_RESOURCE_FILTERS_FAILED,
} from 'legacy/src/constants/types';

const initialState = {
  filters: {},
  isFetching: false,
  errorMessage: '',
};

const resourceFilters = (state = initialState, action) => {
  const { type, payload } = action;
  const { filters, errorMessage } = payload || {};

  switch (type) {
    case FETCH_RESOURCE_FILTERS_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      };
    case FETCH_RESOURCE_FILTERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        filters,
      };
    case FETCH_RESOURCE_FILTERS_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
      };
    default:
      return state;
  }
};

export default resourceFilters;
